<template>
  <div class="body-t">
    <div class="user-box">

      <div class="main-top van-clearfix">
        <div>
          <van-image :src="this.$store.state.auth.company.logo"
                     class="company-logo"
                     fit="contain" lazy-load
          >
            <template v-slot:error>无企业LOGO</template>
          </van-image>
        </div>
        <div>
          <div class="company-title">
            {{ this.$store.state.auth.company.CompanyName ? this.$store.state.auth.company.CompanyName : "-" }}
          </div>
          <div class="cr-code">
            统一信用代码：{{ this.$store.state.auth.company.CreditCode ? this.$store.state.auth.company.CreditCode : '-' }}
          </div>
        </div>
      </div>
      <div class="user-desc van-clearfix">
        欢迎您，
        <van-icon name="user-o"/>
        {{ this.$store.state.auth.RealName ? this.$store.state.auth.RealName : '优采用户' }}（{{
          this.$store.state.auth.Phone
        }}）
      </div>

    </div>

    <div class="pd-10">
      <div class="top-bat-tool">
        <div>
          快捷菜单
        </div>
        <div style="margin-top: 10px">
          <van-grid :border="false" class="tool-show">
            <van-grid-item icon="todo-list-o" text="与我联系" to="/colllist"/>
            <van-grid-item icon="gem-o" text="招采VIP" url="http://m.youcaiyun.com/OnlinePay/WechatPay/VipPay.aspx"/>
            <van-grid-item icon="points" text="地产智库" url="http://m.xiazai.dichan.com/"/>
            <van-grid-item icon="send-gift-o" text="优采研学社" url="https://study.youcaiyun.com/"/>
          </van-grid>
        </div>
      </div>
      <div class="show-tit">
        我的账户
      </div>

      <van-button :loading="load.logout" block color="linear-gradient(to right, #ff6034, #ee0a24)"
                  loading-text="退出登录中..."
                  @click="logout">退出登录
        <van-icon name="arrow"/>
      </van-button>


    </div>


  </div>
</template>

<script>

export default {
  name: "My",
  metaInfo: {
    title: '个人中心 @优采云大数据服务平台',
    htmlAttrs: {
      lang: 'zh-CN',
      keyword:'优采云，大数据，云服务，报告',
      amp: true
    }
  },
  data() {
    return {
      load: {
        logout: false
      }
    }
  },
  methods: {
    logout() {
      this.load.logout = true
      this.$axios.post(this.$apiconfg.login_out, {
        option: 'login_out'
      }).then(() => {
        this.load.logout = false
        this.$store.commit('loginOut')
        this.$router.push('/login')
      }).catch(() => {
        this.load.logout = false
      })

    },
  }
}
</script>

<style scoped>
.pd-10 {
  padding: 10px;
}

.user-box {
  min-height: 170px;
  background: linear-gradient(
      296deg, #2E2A29 0%, #404040 100%);
  padding: 25px 10px;
  box-sizing: border-box;
  box-shadow: 0px 2px 25px -5px #646566;
  position: relative;
}

.user-box::before {
  content: " ";
  background: url("~@/assets/images/bg_rank.png") no-repeat;
  background-size: contain;
  height: 120px;
  width: 75px;
  position: absolute;
  top: 0;
  right: 0;
}

.body-t {
  background: #eff3f6;
  height: calc(100vh - 50px);
}

.main-top {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(194, 150, 94, .2)
}

.main-top > div {
  float: left;
  box-sizing: border-box;
}

.main-top > div:nth-child(1) {
  width: 120px;
  margin-right: 10px;
}

.main-top > div:nth-child(2) {
  width: calc(100% - 130px);
  display: grid;
  height: 65px;
  align-items: center;
}

.company-logo {
  width: 100%;
  height: 65px;
  display: block;
  background: white;
  object-fit: contain;
  border-radius: 3px;
  box-sizing: border-box;
}

.company-title {
  color: #E8B279;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
}

.cr-code {
  font-size: 12px;
  color: rgba(232, 191, 162, .6);
}

.user-desc {
  margin-top: 10px;
  background: rgba(232, 191, 162, .1);
  border-radius: 3px;
  padding: 10px;
  font-size: 12px;
  color: goldenrod;
  line-height: 24px;
  text-align: center;
}


.show-tit {
  font-size: 12px;
  color: #666666;
  margin: 20px auto 10px;
}

.top-bat-tool {
  background: rgba(255, 255, 255, .8);
  border-radius: 5px;
  padding: 10px 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 12px;
}

.tool-show /deep/ .van-grid-item__content {
  background: transparent;
}

.tool-show /deep/ .van-icon {
  color: #e8b279;
}
</style>